<div *ngFor="let linkPreview of clausePreviews" class="clause-preview">
  {{ linkPreview }}
</div>
